import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listTradingPartners } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListTradingPartnersRequestSchema,
  type ListTradingPartnersResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 取引先マスタ 一覧取得 hook。
 *
 * response → 表示行への変換は `../models/convert.ts` の
 * `convertTradingPartnerListItem` に共通化されている。
 */
export function useListTradingPartners(): UseQueryResult<
  ListTradingPartnersResponse,
  ConnectError
> {
  return useQuery(listTradingPartners, create(ListTradingPartnersRequestSchema))
}
